/** @jsx jsx */
import { jsx } from 'theme-ui'
import L from 'lodash'
import { AssetType } from '@spectral/types'
import View from '../../../blocks/source-integration/independent-integrations/jira'
import { useStatsFetch } from './use-stats-fetch'

const JiraSourceIntegration = ({
  source: { data },
  setIsTeamTokenShown,
  shouldShowTeamToken,
}) => {
  const [assetKindsStats, loaded] = useStatsFetch()
  const isConnected = L.find(
    assetKindsStats,
    ({ assetType, total }) => assetType === AssetType.Jira && total > 0
  )
  return (
    <View
      dataSource={data}
      isConnected={isConnected}
      statusLoaded={loaded}
      onSwitchTokenShown={setIsTeamTokenShown}
      shouldShowTeamToken={shouldShowTeamToken}
    />
  )
}

export default JiraSourceIntegration
